import { motion } from "framer-motion";
import { Calendar, Clock, MapPin, Navigation } from "lucide-react";

const MAPS_QUERY = encodeURIComponent("Área de Lazer do Condomínio Meridian, Goianésia - GO");

const CARDS = [
  { icon: Calendar, title: "31 de Outubro de 2026", sub: "Sábado" },
  { icon: Clock, title: "A partir das 15h", sub: "Chegue com tranquilidade" },
  { icon: MapPin, title: "Condomínio Meridian", sub: "Área de Lazer — Goianésia, GO" },
];

export default function Details() {
  return (
    <section data-testid="event-details" className="px-6 py-24 md:py-32">
      <div className="max-w-5xl mx-auto text-center">
        <motion.p
          className="text-xs tracking-[0.45em] uppercase"
          style={{ color: "var(--muted)" }}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          O grande dia
        </motion.p>
        <motion.h2
          className="font-display gold-text text-3xl sm:text-4xl lg:text-5xl mt-3"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          Quando &amp; Onde
        </motion.h2>

        <div className="grid sm:grid-cols-3 gap-5 mt-14">
          {CARDS.map(({ icon: Icon, title, sub }, i) => (
            <motion.div
              key={title}
              className="lux-card px-6 py-8 flex flex-col items-center gap-3"
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
            >
              <Icon className="w-7 h-7" style={{ color: "var(--gold)" }} />
              <p className="text-base md:text-lg tracking-[0.1em] font-medium">{title}</p>
              <p className="text-xs tracking-[0.25em] uppercase" style={{ color: "var(--muted)" }}>
                {sub}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="mt-14 p-2 md:p-3 lux-card"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8 }}
        >
          <iframe
            title="Mapa do evento"
            data-testid="event-map"
            src={`https://www.google.com/maps?q=${MAPS_QUERY}&output=embed`}
            className="w-full h-[320px] md:h-[400px] border-0"
            style={{ filter: "grayscale(1) sepia(0.35) contrast(0.95)" }}
            loading="lazy"
          />
        </motion.div>

        <motion.a
          data-testid="open-maps-link"
          href={`https://www.google.com/maps/search/?api=1&query=${MAPS_QUERY}`}
          target="_blank"
          rel="noreferrer"
          className="lux-btn mt-8"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
        >
          <Navigation className="w-4 h-4" /> Como chegar
        </motion.a>
      </div>
    </section>
  );
}
